import { OptionI, OptionItemsI, ResponseAddMenuI } from 'interfaces';
import { deleteById, get, patch, post } from 'services/services.methods';
import { OptionsMenu } from 'services/services.paths';

export const OptionsMenuService = async () => {
  const response = await get<OptionItemsI[]>(OptionsMenu.options);

  return response;
};

export const AddOptionsMenuService = async (option: OptionI) => {
  const response = await post<ResponseAddMenuI>(OptionsMenu.options, option);

  return response;
};

export const DeleteOptionsMenuService = async (id: number) => {
  const response = await deleteById<ResponseAddMenuI>(OptionsMenu.options, id);

  return response;
};

export const UpdateOptionsMenuService = async (id: number, option: OptionI) => {
  const response = await patch<ResponseAddMenuI>(OptionsMenu.options + "/"+id, option);

  return response;
};

